import { Routes } from '@angular/router';
import { AuthGuard } from '@utils/guards/auth.guard';

export const dividendsRoutes: Routes = [
  {
    path: 'dividendos',
    loadComponent: () =>
      import('./dividends.component').then((c) => c.DividendsComponent),
    canActivate: [AuthGuard],
  },
];
